"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SportNameEnum = exports.SportsEnum = void 0;
var SportsEnum;
(function (SportsEnum) {
    SportsEnum[SportsEnum["SOFTBALL"] = 1] = "SOFTBALL";
    SportsEnum[SportsEnum["BASKETBALL"] = 2] = "BASKETBALL";
    SportsEnum[SportsEnum["FOOTBALL"] = 3] = "FOOTBALL";
    SportsEnum[SportsEnum["SOCCER"] = 4] = "SOCCER";
    SportsEnum[SportsEnum["BOWLING"] = 5] = "BOWLING";
    SportsEnum[SportsEnum["BOCCEBALL"] = 6] = "BOCCEBALL";
    SportsEnum[SportsEnum["CORNHOLE"] = 7] = "CORNHOLE";
    SportsEnum[SportsEnum["DODGEBALL"] = 8] = "DODGEBALL";
    SportsEnum[SportsEnum["FRISBEE"] = 9] = "FRISBEE";
    SportsEnum[SportsEnum["HOCKEY"] = 10] = "HOCKEY";
    SportsEnum[SportsEnum["KICKBALL"] = 11] = "KICKBALL";
    SportsEnum[SportsEnum["LACROSSE"] = 12] = "LACROSSE";
    SportsEnum[SportsEnum["PINGPONG"] = 13] = "PINGPONG";
    SportsEnum[SportsEnum["RUGBY"] = 14] = "RUGBY";
    SportsEnum[SportsEnum["SKEEBALL"] = 15] = "SKEEBALL";
    SportsEnum[SportsEnum["TENNIS"] = 16] = "TENNIS";
    SportsEnum[SportsEnum["VOLLEYBALL"] = 17] = "VOLLEYBALL";
    SportsEnum[SportsEnum["WIFFLEBALL"] = 18] = "WIFFLEBALL";
    SportsEnum[SportsEnum["BADMINTON"] = 19] = "BADMINTON";
    SportsEnum[SportsEnum["FITNESS"] = 20] = "FITNESS";
    SportsEnum[SportsEnum["GOLF"] = 21] = "GOLF";
    SportsEnum[SportsEnum["PILATES"] = 22] = "PILATES";
    SportsEnum[SportsEnum["RUNNING"] = 23] = "RUNNING";
    SportsEnum[SportsEnum["SKIING"] = 24] = "SKIING";
    SportsEnum[SportsEnum["SNOWBOARDING"] = 25] = "SNOWBOARDING";
    SportsEnum[SportsEnum["YOGA"] = 26] = "YOGA";
    SportsEnum[SportsEnum["BROOMBALL"] = 27] = "BROOMBALL";
    SportsEnum[SportsEnum["CRICKET"] = 28] = "CRICKET";
    SportsEnum[SportsEnum["CROSSFIT"] = 29] = "CROSSFIT";
    SportsEnum[SportsEnum["CYCLING"] = 30] = "CYCLING";
    SportsEnum[SportsEnum["FIELD_HOCKEY"] = 31] = "FIELD_HOCKEY";
    SportsEnum[SportsEnum["RACQUETBALL"] = 32] = "RACQUETBALL";
    SportsEnum[SportsEnum["SPINNING"] = 33] = "SPINNING";
    SportsEnum[SportsEnum["SQUASH"] = 34] = "SQUASH";
    SportsEnum[SportsEnum["SURFING"] = 35] = "SURFING";
    SportsEnum[SportsEnum["SWIMMING"] = 36] = "SWIMMING";
    SportsEnum[SportsEnum["WIND_SURFING"] = 37] = "WIND_SURFING";
    SportsEnum[SportsEnum["ADVENTURE"] = 38] = "ADVENTURE";
    SportsEnum[SportsEnum["BOXING"] = 39] = "BOXING";
    SportsEnum[SportsEnum["BASEBALL"] = 40] = "BASEBALL";
    SportsEnum[SportsEnum["DANCE"] = 41] = "DANCE";
    SportsEnum[SportsEnum["KICKBOXING"] = 42] = "KICKBOXING";
    SportsEnum[SportsEnum["MARTIAL_ARTS"] = 43] = "MARTIAL_ARTS";
    SportsEnum[SportsEnum["OUTDOORS"] = 44] = "OUTDOORS";
    SportsEnum[SportsEnum["ROWING"] = 45] = "ROWING";
    SportsEnum[SportsEnum["SAILING"] = 46] = "SAILING";
    SportsEnum[SportsEnum["SUP"] = 47] = "SUP";
    SportsEnum[SportsEnum["TRIATHLON"] = 48] = "TRIATHLON";
    SportsEnum[SportsEnum["HANDBALL"] = 49] = "HANDBALL";
    SportsEnum[SportsEnum["CATCHBALL"] = 50] = "CATCHBALL";
    SportsEnum[SportsEnum["BLITZBALL"] = 51] = "BLITZBALL";
    SportsEnum[SportsEnum["ROLLER_DERBY"] = 52] = "ROLLER_DERBY";
    SportsEnum[SportsEnum["ICE_SKATING"] = 53] = "ICE_SKATING";
    SportsEnum[SportsEnum["PICKLEBALL"] = 54] = "PICKLEBALL";
    SportsEnum[SportsEnum["AXE_THROWING"] = 55] = "AXE_THROWING";
    SportsEnum[SportsEnum["FUTSAL"] = 56] = "FUTSAL";
    SportsEnum[SportsEnum["BIRTHDAY"] = 57] = "BIRTHDAY";
    SportsEnum[SportsEnum["CORPORATE_EVENTS"] = 58] = "CORPORATE_EVENTS";
    SportsEnum[SportsEnum["CURLING"] = 59] = "CURLING";
    SportsEnum[SportsEnum["GYMNASTICS"] = 60] = "GYMNASTICS";
    SportsEnum[SportsEnum["FIGURE_SKATING"] = 61] = "FIGURE_SKATING";
    SportsEnum[SportsEnum["CHEER"] = 62] = "CHEER";
    SportsEnum[SportsEnum["OTHER"] = 999] = "OTHER";
})(SportsEnum = exports.SportsEnum || (exports.SportsEnum = {}));
var SportNameEnum;
(function (SportNameEnum) {
    SportNameEnum["SOFTBALL"] = "softball";
    SportNameEnum["BASKETBALL"] = "basketball";
    SportNameEnum["FOOTBALL"] = "football";
    SportNameEnum["SOCCER"] = "soccer";
    SportNameEnum["BOWLING"] = "bowling";
    SportNameEnum["BOCCEBALL"] = "bocceball";
    SportNameEnum["CORNHOLE"] = "cornhole";
    SportNameEnum["DODGEBALL"] = "dodgeball";
    SportNameEnum["FRISBEE"] = "frisbee";
    SportNameEnum["HOCKEY"] = "hockey";
    SportNameEnum["KICKBALL"] = "kickball";
    SportNameEnum["LACROSSE"] = "lacrosse";
    SportNameEnum["PINGPONG"] = "pingpong";
    SportNameEnum["RUGBY"] = "rugby";
    SportNameEnum["SKEEBALL"] = "skeeball";
    SportNameEnum["TENNIS"] = "tennis";
    SportNameEnum["VOLLEYBALL"] = "volleyball";
    SportNameEnum["WIFFLEBALL"] = "wiffleball";
    SportNameEnum["BADMINTON"] = "badminton";
    SportNameEnum["FITNESS"] = "fitness";
    SportNameEnum["GOLF"] = "golf";
    SportNameEnum["PILATES"] = "pilates";
    SportNameEnum["RUNNING"] = "running";
    SportNameEnum["SKIING"] = "skiing";
    SportNameEnum["SNOWBOARDING"] = "snowboarding";
    SportNameEnum["YOGA"] = "yoga";
    SportNameEnum["BROOMBALL"] = "broomball";
    SportNameEnum["CRICKET"] = "cricket";
    SportNameEnum["CROSSFIT"] = "crossfit";
    SportNameEnum["CYCLING"] = "cycling";
    SportNameEnum["FIELD_HOCKEY"] = "field_hockey";
    SportNameEnum["RACQUETBALL"] = "racquetball";
    SportNameEnum["SPINNING"] = "spinning";
    SportNameEnum["SQUASH"] = "squash";
    SportNameEnum["SURFING"] = "surfing";
    SportNameEnum["SWIMMING"] = "swimming";
    SportNameEnum["WIND_SURFING"] = "wind_surfing";
    SportNameEnum["ADVENTURE"] = "adventure";
    SportNameEnum["BOXING"] = "boxing";
    SportNameEnum["BASEBALL"] = "baseball";
    SportNameEnum["DANCE"] = "dance";
    SportNameEnum["KICKBOXING"] = "kickboxing";
    SportNameEnum["MARTIAL_ARTS"] = "martial_arts";
    SportNameEnum["OUTDOORS"] = "outdoors";
    SportNameEnum["ROWING"] = "rowing";
    SportNameEnum["SAILING"] = "sailing";
    SportNameEnum["SUP"] = "sup";
    SportNameEnum["TRIATHLON"] = "triathlon";
    SportNameEnum["HANDBALL"] = "handball";
    SportNameEnum["CATCHBALL"] = "catchball";
    SportNameEnum["BLITZBALL"] = "blitzball";
    SportNameEnum["ROLLER_DERBY"] = "roller_derby";
    SportNameEnum["ICE_SKATING"] = "ice_skating";
    SportNameEnum["PICKLEBALL"] = "pickleball";
    SportNameEnum["AXE_THROWING"] = "axe_throwing";
    SportNameEnum["FUTSAL"] = "futsal";
    SportNameEnum["BIRTHDAY"] = "birthday";
    SportNameEnum["CORPORATE_EVENTS"] = "corporate_events";
    SportNameEnum["CURLING"] = "curling";
    SportNameEnum["GYMNASTICS"] = "gymnastics";
    SportNameEnum["FIGURE_SKATING"] = "figure_skating";
    SportNameEnum["CHEER"] = "cheer";
    SportNameEnum["OTHER"] = "other";
})(SportNameEnum = exports.SportNameEnum || (exports.SportNameEnum = {}));
//# sourceMappingURL=activities.enums.js.map